import { AxiosResponse } from 'axios'
import get from 'lodash/get'
import { IFilter, Where } from 'types/common'
import { api, handleError } from 'API'
import { IMetric, MetricInputType } from 'interfaces/metric'

export async function getMetrics(filter: IFilter<IMetric> = {}, includeDeleted?: boolean): Promise<IMetric[]> {
  try {
    const response: AxiosResponse = await api.get('/metrics', {
      params: { filter: JSON.stringify(filter), ...(includeDeleted && { includeDeleted: true }) }
    })
    return response.data
  } catch (error: any) {
    handleError(error as Error, 'API/metric/index.ts', 'getMetrics', false, true)
    return []
  }
}

export async function countMetrics(where: Where<IMetric> = {}): Promise<number> {
  try {
    const response: AxiosResponse = await api.get('/metrics/count', {
      params: { where: JSON.stringify(where) }
    })
    return Number(get(response.data, 'count', 0))
  } catch (error: any) {
    handleError(error as Error, 'API/metric/index.ts', 'countMetrics', false)
    return 0
  }
}

export interface ICreateMetricDto {
  name: string
  inputType: MetricInputType
  description?: string
}

export async function createMetric(payload: ICreateMetricDto): Promise<IMetric> {
  const response: AxiosResponse = await api.post('/metrics', payload)
  return response.data
}

export async function updateMetric(id: number, payload: Partial<IMetric>): Promise<void> {
  await api.patch(`/metrics/${id}`, payload)
}

export async function deleteMetric(id: number): Promise<void> {
  await api.delete(`/metrics/${id}`)
}
